console.log("tableaux.js");

(function () {
  const SEUIL = 700;

  // ── utilitaires ──────────────────────────────────────────────────────────────

  function nettoyerStyles(table) {
    const attrs = ['height', 'style', 'width', 'cellspacing', 'cellpadding', 'bgcolor'];
    [table, ...table.querySelectorAll('col, tr, td, th, span')].forEach(el => {
      attrs.forEach(attr => el.removeAttribute(attr));
    });
  }

  function getContainer(table) {
    const arbre = table.closest('.tag__arbre');
    return arbre ? table.closest('.toolbox') : table.closest('div');
  }

  function largeurContainer(table) {
    const c = getContainer(table);
    return c ? c.offsetWidth : window.innerWidth;
  }

  // ── classification ────────────────────────────────────────────────────────────

  function classifier(table) {
    const aTheadTh = table.querySelectorAll('thead th').length > 0;
    const aTbodyTh = table.querySelectorAll('tbody tr th').length > 0;

    if (aTheadTh && aTbodyTh) return 'double';
    if (aTbodyTh)              return 'verticale';
    if (aTheadTh)              return 'horizontale';
    return 'sans';
  }

  // ── gestion des data-value (titres de colonnes dans les cellules) ─────────────

  function injecterDataValues(table, type) {
  if (type !== 'horizontale' && type !== 'double') return;

  const ths = [...table.querySelectorAll('thead tr:first-child th')];

  table.querySelectorAll('tbody tr').forEach(tr => {
    [...tr.querySelectorAll('td')].forEach((td, i) => {
      const index = type === 'double' ? i + 1 : i;
      const th = ths[index];

      if (th) {
        td.dataset.value = th.textContent.trim();
      }
    });
  });
}

  function supprimerDataValues(table) {
    table.querySelectorAll('td[data-value]').forEach(td => delete td.dataset.value);
  }

  // ── modes d'affichage ─────────────────────────────────────────────────────────

  function modeDesktop(table, type) {
    table.classList.remove('tableau--minifie');
    table.querySelector('thead')?.classList.remove('tableau__thead--masque');
    table.querySelectorAll('tbody tr td:first-child').forEach(td =>
      td.classList.remove('tableau__td--entete-ligne')
    );
    supprimerDataValues(table);

    if (type === 'double' || type === 'verticale') {
      table.querySelectorAll('tbody tr td:first-child').forEach(td =>
        td.classList.remove('tableau__td--entete-ligne')
      );
    }
  }

  function modeMinifie(table, type) {
    table.classList.add('tableau--minifie');

    if (type === 'horizontale' || type === 'double') {
      table.querySelector('thead')?.classList.add('tableau__thead--masque');
      injecterDataValues(table, type);
    }

    if (type === 'verticale' || type === 'double') {
      table.querySelectorAll('tbody tr td:first-child').forEach(td =>
        td.classList.add('tableau__td--entete-ligne')
      );
    }

    if (type === 'sans') {
      table.querySelectorAll('tr').forEach(tr =>
        tr.classList.add('tableau__tr--separateur')
      );
    }
  }

  // ── décision desktop / minifié ────────────────────────────────────────────────

  function nombreColonnes(table, type) {
    if (type === 'horizontale' || type === 'double') {
      return table.querySelectorAll('thead th').length;
    }
    const premiereLigne = table.querySelector('tr');
    return premiereLigne ? premiereLigne.querySelectorAll('td').length : 0;
  }

  function appliquer(table, type) {
    const larg = largeurContainer(table);
    const cols = nombreColonnes(table, type);
    const doitMinifier = larg < SEUIL || cols >= 6;

    if (doitMinifier) {
      modeMinifie(table, type);
    } else {
      modeDesktop(table, type);
    }
  }

  // ── initialisation ────────────────────────────────────────────────────────────

  function initTableau(table) {
    nettoyerStyles(table);

    const type = classifier(table);
    const classes = {
      double:      'tableau--double-entree',
      verticale:   'tableau--simple-entree-verticale',
      horizontale: 'tableau--simple-entree-horizontale',
      sans:        'tableau--sans-entree',
    };
    table.classList.add(classes[type]);

    if (table.closest('.tag__arbre')) {
      table.classList.add('tableau--dans-arbre');
    }

    table.dataset.tableauType = type;
    appliquer(table, type);

    // révèle le tableau
    table.style.display = 'table';
    table.style.opacity = '0';
    requestAnimationFrame(() => {
      table.style.transition = 'opacity .3s';
      table.style.opacity = '1';
    });
  }

  document.querySelectorAll('table').forEach(initTableau);

  // ── resize ────────────────────────────────────────────────────────────────────

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll('table[data-tableau-type]').forEach(table => {
        appliquer(table, table.dataset.tableauType);
      });
    }, 150);
  });

})();